import { render, staticRenderFns } from "./InformUser.vue?vue&type=template&id=2778b71c&"
import script from "./InformUser.vue?vue&type=script&lang=js&"
export * from "./InformUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports